"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AwardBadgeType = void 0;
/**
 * Award Badge Type.
 */
var AwardBadgeType;
(function (AwardBadgeType) {
    AwardBadgeType["NATIVE"] = "native";
    AwardBadgeType["BASE"] = "base";
})(AwardBadgeType = exports.AwardBadgeType || (exports.AwardBadgeType = {}));
